import { Horse } from "./horse";
import { AccountRole } from "./accountRole";
import { AccountMembership } from './accountMembership';
import { Stat } from "./stat";
import { Trade } from './trade';
import { Video } from './video';
import { Notification } from './notification';
import { ScheduledNotification } from './scheduledNotification';
import { AccountFamily } from "./accountFamily";
import { Photo } from "./photo";

export class Account {
    id: number;
    emailAddress: string = '';
    male: boolean;
    firstName: string = '';
    lastName: string = '';
    displayName: string = '';
    profilePicFileName: string;
    birthDate: string = '';
    phone: string = '';
    streetAddress: string = '';
    country: string = '';
    city: string = '';
    state: string;
    zip: string = '';
    wcrA_ERAUID: string = '';

    familyMembers: AccountFamily[] = [];
    memberships: AccountMembership[] = [];

    horses: Horse[] = [];
    videos: Video[] = [];
    photos: Photo[] = [];
    roles: AccountRole[] = [];
    stats: Stat[] = [];
    outgoingTrades: Trade[] = [];
    incomingTrades: Trade[] = [];
    scheduledNotifications: ScheduledNotification[] = [];
    notifications: Notification[] = [];

    isSetup() : boolean {
        if (!this.firstName || !this.lastName || !this.birthDate || !this.city || !this.state)
            return false;

        return true;
    }

    public static create(item: Account) : Account {
        let account = new Account();
        account.id = item.id;
        account.emailAddress = item.emailAddress;
        account.male = item.male;
        account.firstName = item.firstName;
        account.lastName = item.lastName;
        account.displayName = item.displayName;
        account.profilePicFileName = item.profilePicFileName;
        account.birthDate = item.birthDate;
        account.phone = item.phone;
        account.streetAddress = item.streetAddress;
        account.city = item.city;
        account.country = item.country;
        account.state = item.state;
        account.zip = item.zip;
        account.memberships = item.memberships;
        account.familyMembers = item.familyMembers;
        account.wcrA_ERAUID = item.wcrA_ERAUID;

        account.horses = item.horses;
        account.videos = item.videos;
        account.roles = item.roles;
        account.stats = item.stats;
        account.outgoingTrades = item.outgoingTrades;
        account.incomingTrades = item.incomingTrades;
        account.scheduledNotifications = item.scheduledNotifications;
        account.notifications = item.notifications;

        return account;
    }
}


// WEBPACK FOOTER //
// ./src/model/account.ts